import ModalBody from './ModalBody'
export default ModalBody
